import { CCol, CFormInput, CFormLabel, CRow } from '@coreui/react-pro'
import { CColProps } from '@coreui/react-pro/dist/components/grid/CCol'
import { CRowProps } from '@coreui/react-pro/dist/components/grid/CRow'
import React from 'react'
import { InputField } from '../../types/EmployeeDirectory/EmployeesList/AddNewEmployee/addNewEmployeeType'
import {
  booleanMandatory,
  conditionalDefaultStringEmpty,
  dynamicFormLabelProps,
  isEmail,
  showIsRequired,
  StringEmpty,
} from '../../utils/helper'

const OInputField = ({
  dynamicFormLabelProps,
  onChangeHandler,
  onBlurHandler,
  value,
  type: inputType,
  isRequired,
  label,
  name,
  placeholder,
  valueValidation,
}: InputField): JSX.Element => {
  const isInvalid = isEmail(value)
  const handleOnChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeHandler == null) return

    onChangeHandler(e.target.value)
  }

  const handleOnBlurInput = () => {
    if (onBlurHandler == null) return

    onBlurHandler(value)
  }

  return (
    <>
      <CRow className="mb-3">
        <CFormLabel
          data-testid={name}
          {...dynamicFormLabelProps(
            name,
            'col-sm-3 col-form-label text-md-end',
          )}
        >
          {label} :
          {isRequired && (
            <span
              className={
                valueValidation ? valueValidation(value) : showIsRequired(value)
              }
            >
              *
            </span>
          )}
        </CFormLabel>
        <CCol sm={3}>
          <CFormInput
            id={name}
            data-testid={name}
            size="sm"
            type={inputType == null ? 'text' : inputType}
            name={name}
            placeholder={placeholder}
            value={value}
            onBlur={handleOnBlurInput}
            onChange={handleOnChangeInput}
            autoComplete={'off'}
          />
          {inputType === 'email' && isInvalid ? (
            <span style={{ color: 'red' }}>Enter a valid Email address</span>
          ) : null}
        </CCol>
      </CRow>
    </>
  )
}

export const OInputFieldDynamic = (props: {
  setValueHandler?: (
    event:
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>,
  ) => void
  name: string // its the name, id, data-testid of the select
  label: string

  readonly?: boolean
  isRequired?: boolean
  placeHolder?: string
  value?: string
  labelClassName?: string
  inputClassName?: string
  labelColumnType?: CColProps
  inputColumnType?: CColProps
  inputMainColType?: CColProps
  inputMainRowType?: CRowProps
  size?: 'sm' | 'lg'
  type?: string
  autoComplete?: 'on' | 'off'
}): JSX.Element => {
  const selectedValue = props?.value == null ? '' : props?.value
  const requiredLabel = props?.isRequired ?? false
  const labelColumnTypeValue = props?.labelColumnType ?? {
    sm: { span: 3, offset: 0 },
    lg: { span: 3, offset: 0 },
  }
  const selectColumnType = props?.inputColumnType ?? {
    sm: { span: 3, offset: 0 },
  }
  return (
    <CCol {...props?.inputMainColType}>
      <CRow {...props?.inputMainRowType}>
        <CCol {...labelColumnTypeValue} className="text-md-end">
          <CFormLabel
            data-testid={`inputLabel-${props.name}`}
            {...dynamicFormLabelProps(
              props.label,
              conditionalDefaultStringEmpty(
                props?.labelClassName,
                'col-form-label',
              ),
            )}
          >
            {props?.label ? `${props?.label}: ` : ''}
            {requiredLabel && (
              <span className={booleanMandatory(StringEmpty(selectedValue))}>
                *
              </span>
            )}
          </CFormLabel>
        </CCol>
        <CCol {...selectColumnType}>
          <CFormInput
            className={props?.inputClassName}
            id={props.name}
            name={props.name}
            data-testid={`inputfield-${props.name}`}
            readOnly={props?.readonly ?? false}
            type={props?.type ?? 'text'}
            placeholder={props?.placeHolder ?? ''}
            size={props.size ?? 'sm'}
            value={conditionalDefaultStringEmpty(props?.value, '')}
            onChange={props.setValueHandler}
            autoComplete={props?.autoComplete ?? 'off'}
          />
        </CCol>
      </CRow>
    </CCol>
  )
}

export default OInputField
